{
  "announcements": {
    "browse": {
      "button": "Go to Browse",
      "paragraphs": [
        "Open Browse to see what you’ll learn first."
      ],
      "title": "Start with the fundamentals",
      "icon": "MdGridView"
    },
    "decks": {
      "button": "Go to Deck",
      "paragraphs": [
        "You’ve unlocked your Deck, where every character you learn waits for its next review."
      ],
      "title": "One more thing",
      "icon": "GoStack"
    },
    "learn": {
      "button": "Go to Learn",
      "paragraphs": [
        "Open Learn to start learning your first characters."
      ],
      "title": "You’re ready",
      "icon": "MdSchool"
    },
    "stats": {
      "button": "Go to Stats",
      "paragraphs": [
        "You’ve unlocked Stats. Open it to see your progress add up as you learn."
      ],
      "title": "Your first character!",
      "icon": "MdInsights"
    }
  },
  "intro": [
    {
      "button": "Continue",
      "kind": "welcome",
      "paragraphs": [
        "Through character mnemonics and conversation missions, you’ll learn Chinese in a way that finally clicks."
      ],
      "title": "Welcome to the Haniverse."
    },
    {
      "button": "Continue",
      "kind": "heard-about",
      "options": [
        {
          "label": "Friends/family",
          "id": "friends-family"
        },
        {
          "label": "TikTok",
          "id": "tiktok"
        },
        {
          "label": "YouTube",
          "id": "youtube"
        },
        {
          "label": "Instagram/Facebook",
          "id": "instagram-facebook"
        },
        {
          "label": "Reddit",
          "id": "reddit"
        },
        {
          "label": "App Store",
          "id": "app-store"
        },
        {
          "label": "Google Search",
          "id": "google-search"
        },
        {
          "label": "News/article/blog",
          "id": "news-article-blog"
        },
        {
          "label": "School/teacher",
          "id": "school-teacher"
        },
        {
          "label": "Other",
          "id": "other"
        }
      ],
      "title": "How did you hear about Haniverse?"
    },
    {
      "button": "Continue",
      "kind": "reasons",
      "options": [
        {
          "label": "Prepare for travel",
          "emoji": "✈️",
          "id": "travel"
        },
        {
          "label": "Connect with people",
          "emoji": "🧑‍🤝‍🧑",
          "id": "connect"
        },
        {
          "label": "Connect with my heritage",
          "emoji": "🏮",
          "id": "heritage"
        },
        {
          "label": "Boost my career",
          "emoji": "💼",
          "id": "career"
        },
        {
          "label": "Support my education",
          "emoji": "📚",
          "id": "education"
        },
        {
          "label": "Enjoy shows, music and games",
          "emoji": "🎬",
          "id": "media"
        },
        {
          "label": "Spend time productively",
          "emoji": "🧠",
          "id": "productive"
        },
        {
          "label": "Just for fun",
          "emoji": "🎉",
          "id": "fun"
        },
        {
          "label": "Other",
          "emoji": "💬",
          "id": "other"
        }
      ],
      "title": "Why are you learning Chinese?"
    },
    {
      "button": "I’m committed",
      "kind": "daily-goal",
      "options": [
        {
          "label": "5 min / day",
          "minutes": 5,
          "pace": "Casual"
        },
        {
          "label": "10 min / day",
          "minutes": 10,
          "pace": "Regular"
        },
        {
          "label": "15 min / day",
          "minutes": 15,
          "pace": "Serious"
        },
        {
          "label": "20 min / day",
          "minutes": 20,
          "pace": "Intense"
        }
      ],
      "title": "What’s your daily learning goal?"
    },
    {
      "button": "Get Started",
      "items": [
        {
          "emoji": "🗣️",
          "subtitle": "Real-world conversation missions, all across China",
          "title": "Converse with confidence"
        },
        {
          "emoji": "🀄",
          "subtitle": "A memorable mnemonic for every character and its sound",
          "title": "Read about {characters} characters"
        },
        {
          "emoji": "⏰",
          "subtitle": "{minutes} minutes a day, at your own pace",
          "title": "Build a learning habit"
        }
      ],
      "kind": "summary",
      "title": "Here’s what you can achieve in 3 months!"
    }
  ],
  "introductions": {
    "browse": [
      {
        "id": "characters",
        "button": "Next",
        "paragraphs": [
          "Chinese is written in characters (汉字, hànzì). Each one has a meaning, and most are built from a handful of simpler pieces. Learn the pieces, and new characters click."
        ],
        "title": "Characters"
      },
      {
        "id": "pinyin",
        "button": "Next",
        "paragraphs": [
          "Pinyin spells out how a character sounds. Its tone marks (mā, má, mǎ, mà) show how your voice moves, and a different tone can be a different word."
        ],
        "title": "Pinyin"
      },
      {
        "id": "ready",
        "button": "Continue",
        "paragraphs": [
          "The Ready pack comes first. It teaches the strokes and building blocks behind every character, and the sounds of Mandarin, so you’ll be ready to learn and pronounce any character."
        ],
        "title": "The Ready pack"
      }
    ],
    "decks": [
      {
        "id": "decks-deck",
        "button": "Next",
        "paragraphs": [
          "Every character you learn joins your Deck. Each one comes back for review just before you’d forget it, so it sticks."
        ],
        "title": "Your Deck"
      },
      {
        "id": "decks-reviews",
        "button": "Back to Learn",
        "icon": "MdSchool",
        "paragraphs": [
          "Reviews shows which cards are coming up, and when. Once they are due, Learn brings them back to you."
        ],
        "title": "Reviews"
      }
    ],
    "map": [
      {
        "id": "map",
        "button": "Continue",
        "paragraphs": [
          "Very soon, you’ll be travelling around China, practicing real-world conversations.",
          "But first, we need to learn the fundamentals of Chinese."
        ],
        "title": "This is your Map"
      }
    ],
    "stats": [
      {
        "id": "stats-progress",
        "button": "Next",
        "paragraphs": [
          "Every card you learn is counted here. With each review it moves on from New to Familiar, Proficient and finally Mastered."
        ],
        "title": "Your progress"
      },
      {
        "id": "stats-study-time",
        "button": "Continue",
        "paragraphs": [
          "The graph keeps track of how long you study each day. A few minutes every day go further than one long session."
        ],
        "title": "Study time"
      }
    ]
  }
}
